import React from 'react';
import { NumberFormatter } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const styles = {
  block: {
    marginTop: 'large',
    display: 'flex',
    alignItems: 'center',
    height: '26px'
  },
  label: {
    marginRight: 'small'
  }
};

const Subtotal = ({
  quantity,
  determineAddOnCharges,
  isSelectedVariantValid,
  determinePrice,
  translate
}) => {
  const addOnCharges = determineAddOnCharges();
  if (!isSelectedVariantValid() || (quantity < 2 && addOnCharges === 0)) {
    return null;
  }

  const { Block, Heading, Price } = UX2.Element;
  const prices = determinePrice();
  let price = prices.onSale ? prices.salePrice : prices.price;
  price *= quantity;
  const amountFormatted = NumberFormatter.toFormattedCurrency(price, 2, 1);

  return (
    <Block group='Group' style={ styles.block }>
      <Heading.Product children={ translate('products.subtotal') } style={ styles.label } />
      <Price.Major children={ amountFormatted } />
    </Block>
  );
};

Subtotal.propTypes = {
  quantity: PropTypes.number,
  determineAddOnCharges: PropTypes.func,
  isSelectedVariantValid: PropTypes.func,
  determinePrice: PropTypes.func,
  translate: PropTypes.func
};

export default Subtotal;
